import {
	Component,
	OnInit,
	Output,
	OnChanges,
	Input,
	EventEmitter
} from "@angular/core";
import { IHospitalModel } from "../../interfaces";
@Component({
	selector: "app-searchbox",
	templateUrl: "./searchbox.component.html",
	styleUrls: ["./searchbox.component.scss"]
})
export class SearchboxComponent implements OnInit, OnChanges {
	@Input() HOSPITALS: IHospitalModel[];
	@Output() Click = new EventEmitter<IHospitalModel>(true);
	@Input() CONTACTS: any;
	@Output() contactClick = new EventEmitter<any>(true);
	@Input() contactList = false;
	
	constructor() {}

	ngOnInit() {}

	ngOnChanges() {
		"search box".logWithObject("hospitals", this.HOSPITALS);
	}

	OnHospitalClick(model: IHospitalModel) {
		this.Click.emit(model);
	}

	OnNewHospitalClick() {
		this.Click.emit(undefined);
	}

	OnContactCLick(model: IHospitalModel) {
		this.contactClick.emit(model);
	}

	OnNewContactClick() {
		this.contactClick.emit(undefined);
	}



	getAddress(model: IHospitalModel) {
		//return `${model.Hospital.Address.City}, ${model.Hospital.Address.State}`;

		let s = model.Hospital.Address.City ? model.Hospital.Address.City : "";
		s += model.Hospital.Address.State
			? ", " + model.Hospital.Address.State
			: "";
		s += model.Hospital.Address.Country
			? ", " + model.Hospital.Address.Country
			: "";

		return s;
	}

	getContactAddress(model: any) {
		//return `${model.Hospital.Address.City}, ${model.Hospital.Address.State}`;

		let s = model.city ? model.city : "";
		s += model.state
			? ", " + model.state
			: "";
		s += model.country
			? ", " + model.country
			: "";

		return s;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/searchbox/searchbox.component.ts